import { txUrl } from '../config.ts';
import { fmtUsd } from '../lib/format.ts';
import { useApp } from '../state.tsx';
import { cardFromClosed } from './PnlCard.tsx';

export function Toasts() {
  const { toasts, dismiss, markets, globals, openPnlCard } = useApp();
  return (
    <div className="toasts" aria-live="polite">
      {toasts.map((t) => {
        const href = t.href ? txUrl(t.href) : undefined;
        return (
          <div key={t.id} className={`toast toast-${t.kind}`} role={t.kind === 'err' ? 'alert' : 'status'}>
            <div className="toast-title">{t.title}</div>
            {t.body && <div className="toast-body">{t.body}</div>}
            {t.pnl && (
              <div className={`toast-pnl ${t.pnl.net < 0n ? 'neg' : 'pos'}`}>
                <b className="num">{`${t.pnl.net < 0n ? '-' : '+'}$${fmtUsd(t.pnl.net < 0n ? -t.pnl.net : t.pnl.net)}`}</b>
                <span className="num">{`${t.pnl.pct >= 0 ? '+' : ''}${t.pnl.pct.toFixed(1)}%`}</span>
                {t.closed && (
                  <button
                    className="link toast-share"
                    onClick={() => {
                      openPnlCard(cardFromClosed(t.closed!, markets, globals));
                      dismiss(t.id);
                    }}
                  >
                    Share
                  </button>
                )}
              </div>
            )}
            {href && (
              <a href={href} target="_blank" rel="noreferrer">
                view transaction ↗
              </a>
            )}
            <button className="x" onClick={() => dismiss(t.id)} aria-label="Dismiss">
              ×
            </button>
          </div>
        );
      })}
    </div>
  );
}
